import { render, staticRenderFns } from "./formTabelaEstadosCidades.vue?vue&type=template&id=840a545e"
import script from "./formTabelaEstadosCidades.vue?vue&type=script&lang=js"
export * from "./formTabelaEstadosCidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports